import "slick-carousel";
import {isRtl} from "../utils/helpers";

export default class PrimarySlider {
    complexSelector = '.slider-primary > .jet-listing-grid--blocks > .jet-listing-grid > .jet-listing-grid__items';
    simpleSelector = '.slider-primary';
    
    constructor() {
        this.addEvents();
    }

    addEvents() {
        this.initSlickCarousel();
    }

    initSlickCarousel() {
        // Find all complex and simple sliders
        const $complexSliders = $(this.complexSelector);
        const $simpleSliders = $(this.simpleSelector);

        // Initialize each complex slider that hasn't been initialized yet
        $complexSliders.each((index, element) => {
            const $slider = $(element);
            const $parent = $slider.closest('.slider-primary');

            if (!$parent.hasClass('slider-primary--initialized')) {
                const slidesAtXl = this.getSlidesCount($parent);
                this.initializeSlider($slider, slidesAtXl);
                $parent.addClass('slider-primary--initialized');
            }
        });

        // Initialize each simple slider that hasn't been initialized yet and doesn't contain a complex slider
        $simpleSliders.each((index, element) => {
            const $slider = $(element);
            if (!$slider.hasClass('slider-primary--initialized') && !$slider.find(this.complexSelector).length) {
                const slidesAtXl = this.getSlidesCount($slider);
                this.initializeSlider($slider, slidesAtXl);
                $slider.addClass('slider-primary--initialized');
            }
        });
    }

    getSlidesCount($element) {
        const slideClass = $element.closest('.slider-primary').attr('class')?.match(/slides-xl-(\d+)/);
        return slideClass ? parseInt(slideClass[1]) : 4;
    }

    initializeSlider($slider, slidesAtXl) {

        
        $slider.slick({
            slidesToShow: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            mobileFirst: true,
            dots: true,
            rtl: isRtl(),
            customPaging: function(slider, i) {
                return $('<button type="button" />').text(i + 1);
            },
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false,
                        arrows: true
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3,
                        variableWidth: false,
                        arrows: true
                    }
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: slidesAtXl,
                        variableWidth: false,
                        arrows: true
                    }
                }
            ],
            // Fix for RTL mode - ensure transform is positive
            init: function(slick) {
                if (isRTL) {
                    // After initialization, fix the transform value for RTL
                    const $track = $(slick.$slideTrack);
                    const transform = $track.css('transform');
                    if (transform && transform.includes('-')) {
                        // Convert negative transform to positive for RTL
                        const matrix = transform.match(/matrix\((.*)\)/);
                        if (matrix && matrix[1]) {
                            const values = matrix[1].split(',');
                            // If the 5th value (translation X) is negative, make it positive
                            if (values[4] && parseFloat(values[4]) < 0) {
                                values[4] = Math.abs(parseFloat(values[4]));
                                $track.css('transform', `matrix(${values.join(',')})`); 
                            }
                        }
                    }
                }
            }
        });
        
        // Apply custom pagination dots behavior
        this.applyCustomPagination($slider);
    }
    
    applyCustomPagination($slider) {
        // Wait for slick to be fully initialized
        setTimeout(() => {
            const $dots = $slider.find('.slick-dots');
            const $dotsLi = $dots.find('li');
            
            // Only apply custom pagination if we have 5 or more dots
            if ($dotsLi.length >= 5) {
                // Set up pagination update on slide change
                $slider.on('afterChange', (_, __, currentSlide) => {
                    this.updateDotVisibility($dotsLi, currentSlide);
                });
                
                // Initial update
                this.updateDotVisibility($dotsLi, $slider.slick('slickCurrentSlide'));
            }
        }, 100);
    }
    
    updateDotVisibility($dots, currentSlide) {
        // For 5+ dots, show exactly 5 with active in middle position
        const totalDots = $dots.length;
        const visibleDots = 5;
        const dotsBeforeActive = 2;
        
        // Calculate visible range
        let startDot = Math.max(0, currentSlide - dotsBeforeActive);
        let endDot = startDot + visibleDots - 1;
        
        // Adjust if we're near the end
        if (endDot >= totalDots) {
            endDot = totalDots - 1;
            startDot = Math.max(0, endDot - visibleDots + 1);
        }
        
        // Show/hide dots
        $dots.each((i, dot) => {
            $(dot).toggle(i >= startDot && i <= endDot);
        });
    }
}